import { createContext, useContext, useEffect, useState } from 'react'
import type { ReactNode } from 'react'

const SsrDetectorContext = createContext(true)

export function SsrDetectorProvider({ children }: { children: ReactNode }) {
  const [isSsr, setIsSsr] = useState(true)

  useEffect(() => {
    setIsSsr(false)
  }, [])

  return <SsrDetectorContext.Provider value={isSsr}>{children}</SsrDetectorContext.Provider>
}

/** Returns `true` during SSR / first render, `false` after client-side mount. */
export const useIsSsr = () => useContext(SsrDetectorContext)
